import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import cx from 'classnames';
import React, { useState } from 'react';
import Downshift from 'downshift';
import matchSorter from 'match-sorter';
import FormFooter from './FormFooter';
import FormLabel from './FormLabel';
import { config } from '../helpers/config';

var ChoicesMulti = function ChoicesMulti(_ref) {
  var _cx;

  var className = _ref.className,
      disabled = _ref.disabled,
      explanationMessage = _ref.explanationMessage,
      label = _ref.label,
      options = _ref.options,
      placeholder = _ref.placeholder,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      removeItem = _ref.removeItem,
      validationMessage = _ref.validationMessage,
      selected = _ref.selected;

  var _useState = useState(''),
      value = _useState[0],
      setValue = _useState[1];

  var itemToString = function itemToString(item) {
    return item ? item.label : '';
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (selected.length && !value.length && e.keyCode === 8) {
      onChange(selected.slice(0, selected.length - 1));
    }
  };

  var handleInputChange = function handleInputChange(e) {
    setValue(e.target.value);
  };

  var handleChange = function handleChange(item) {
    onChange(name, [].concat(_toConsumableArray(selected), [item])); // Clear out any typed values

    setValue('');
  }; // Prevents the menu from being closed when the user selects an item with a keyboard or mouse


  var stateReducer = function stateReducer(state, changes) {
    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem:
        return Object.assign({}, changes, {
          isOpen: state.isOpen,
          highlightedIndex: state.highlightedIndex
        });

      default:
        return changes;
    }
  };

  var optionsList = value.length ? matchSorter(options, value, {
    keys: ['label']
  }) : options;
  var formGroupClasses = cx('form-group', className, (_cx = {}, _cx[config.classes.notValid] = validationMessage, _cx[config.classes.required] = required, _cx));
  var selectedOptions = []; // Based on current selection to remove from dropdown

  var filteredOptions = optionsList.filter(function (item) {
    return JSON.stringify(selected).indexOf(JSON.stringify(item)) === -1;
  });
  selected.forEach(function (item) {
    if (typeof item !== 'object') {
      var selectedOption = optionsList.find(function (x) {
        return x.value === item;
      });
      selectedOptions.push(selectedOption);
    } else {
      selectedOptions.push(item);
    }
  });
  return React.createElement(Downshift, {
    inputValue: value,
    onChange: handleChange,
    selectedItem: selectedOptions,
    itemToString: itemToString,
    stateReducer: stateReducer
  }, function (downshift) {
    var choicesClasses = cx('choices', {
      'is-focused is-open': downshift.isOpen
    }); // Only re-open menu if we didn't click on `x` within a multi-select item

    var handleContainerClick = function handleContainerClick(e) {
      if (!e.target.classList.contains('choices__button')) {
        downshift.openMenu();
      }
    };

    return React.createElement("div", {
      className: formGroupClasses
    }, React.createElement(FormLabel, downshift.getLabelProps(), label), React.createElement("div", {
      className: "form-choicesSelect",
      disabled: disabled
    }, React.createElement("div", {
      className: choicesClasses,
      "data-type": "select-multiple"
    }, React.createElement("div", {
      className: "choices__inner",
      onClick: handleContainerClick
    }, downshift.selectedItem.length > 0 && React.createElement("div", {
      className: "choices__list choices__list--multiple"
    }, downshift.selectedItem.map(function (item, i) {
      return React.createElement("div", {
        className: "choices__item choices__item--selectable" // eslint-disable-next-line
        ,
        key: i
      }, item.label, removeItem && React.createElement("button", {
        type: "button",
        className: "choices__button",
        onClick: function onClick() {
          return removeItem(item);
        }
      }, "Remove item"));
    })), React.createElement("input", Object.assign({
      className: "choices__input",
      type: "text"
    }, downshift.getInputProps({
      placeholder: placeholder,
      onChange: handleInputChange,
      onKeyDown: handleKeyDown
    })))), downshift.isOpen && React.createElement("div", {
      className: "choices__list choices__list--dropdown is-active"
    }, React.createElement("div", Object.assign({
      className: "choices__list"
    }, downshift.getMenuProps()), filteredOptions.length > 0 ? filteredOptions.map(function (item, index) {
      // eslint-disable-next-line
      var itemClasses = cx('choices__item choices__item--choice', {
        'is-highlighted': downshift.highlightedIndex === index
      });
      return React.createElement("div", Object.assign({
        className: itemClasses
      }, downshift.getItemProps({
        item: item
      }), {
        key: item.value
      }), item.label);
    }) : React.createElement("div", {
      className: "choices__item choices__item--choice has-no-choices"
    }, "No choices to choose from"))))), React.createElement(FormFooter, {
      explanationMessage: explanationMessage,
      validationMessage: validationMessage
    }));
  });
};

ChoicesMulti.defaultProps = {
  placeholder: 'Select',
  selected: []
};
export default ChoicesMulti;